// CalendarPanel.tsx
import * as React from 'react';
import { DayPicker } from 'react-day-picker';
import { fr } from 'date-fns/locale';

// CalendarPanel.tsx
type CalendarPanelProps = {
	value?: Date;
	onSelect: (date: Date) => void; // reçoit directement la fonction du parent
	showTime: boolean;
};

export function CalendarPanel({
	value,
	onSelect,
	showTime,
}: CalendarPanelProps) {
	// Hook de state pour le mois affiché dans le calendrier
	const [month, setMonth] = React.useState<Date | undefined>(value);

	// Hook d'effet pour synchroniser le mois affiché avec la valeur sélectionnée
	React.useEffect(() => {
		if (value) {
			setMonth(value);
		}
	}, [value]);

	return (
		<DayPicker
			mode="single"
			selected={value}
			month={month}
			onMonthChange={setMonth}
			onSelect={(date) => {
				if (!date) return;

				const hours = value?.getHours() ?? 12;
				const minutes = value?.getMinutes() ?? 0;
				const d = new Date(date);
				d.setHours(showTime ? hours : 12, showTime ? minutes : 0, 0, 0);

				onSelect(d); // DatePicker gère fermeture si nécessaire
			}}
			locale={fr}
			weekStartsOn={1}
			fixedWeeks
		/>
	);
}
